export default __webpack_public_path__ + "static/media/home.f50a9848.mp4";